// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, Fragment} from 'react';
import styles from '../../pages/toolip.io/dashboard.module.less';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Svg_trash from '../../img/dashboard/trash.svg';
import {Button} from '../../../../hola/pub/lib/button';
import {t_orders} from '../../../../hola/pub/ui/pro/cp/orders';
import {get_orders_stats, show_free_plan_promo} from './utils';
import {Welcome_promo} from './welcome_promo';
import {useHistory} from 'react-router';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_app_context} from '../../lib/app_context';

export const Overview = ()=>{
    const {dashboard} = use_app_context();
    const {info} = dashboard;
    const {orders, free_zone_params} = info;
    const history = useHistory();
    const show_promo = show_free_plan_promo(orders, free_zone_params);
    // const total_orders = total_orders_count(orders);
    // if (total_orders==0)
    //     history.push('/dashboard/page/plans');
    history.push('/dashboard/page/plans');

    return <Fragment>
      {show_promo ?
        <Welcome_promo /> :
        <Welcome_info orders={orders}/>}
    </Fragment>;
};

const Welcome_info = ({orders}:{orders: t_orders})=>{
    const stats = get_orders_stats(orders);
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <Fragment>
      <h4 className={styles.mb32}><T>Welcome back</T></h4>
      <p className={cn(theme.p1, theme.med, theme.color_n700, styles.mb24)}>
      <T>Some of your numbers so far:</T></p>
      <div className={cn(styles.welcome_stats, styles.mb48)}>
        <div className={cn(styles.stats_item, styles.generated,
          stats.generated_amount>99 && styles.wide)}>
          <div className={cn(styles.number, theme.p22, theme.med)}>
            {stats.generated_amount}</div>
          <p className={cn(theme.u4, theme.color_n700)}>
            <T>Generated proxies</T></p>
        </div>
        <div className={cn(styles.stats_item, styles.plans,
          stats.active_plans>99 && styles.wide)}>
          <div className={cn(styles.number, theme.p22, theme.med)}>
            {stats.active_plans}</div>
          <p className={cn(theme.u4, theme.color_n700)}><T>Active plans</T></p>
        </div>
        <div className={cn(styles.stats_item, styles.countries,
          stats.countries_accessed>99 && styles.wide)}>
          <div className={cn(styles.number, theme.p22, theme.med)}>
            {stats.countries_accessed}</div>
          <p className={cn(theme.u4, theme.color_n700)}>
            <T>Accessed countries</T></p>
        </div>
      </div>
      <p className={cn(theme.p1, theme.med, theme.color_n700, styles.mb24)}>
        <T>Your usage stats:</T></p>
      {stats.active_plans > 0 ? <div className={styles.welcome_usage}>
        <div className={styles.stats_item}>
          <p className={cn(theme.u4, theme.med, theme.color_n700)}>
            <T>Proxy usage</T></p>
          <Coming_soon_label/>
        </div>
        <div className={styles.stats_item}>
          <p className={cn(theme.u4, theme.med, theme.color_n700)}>
            <T>Bandwidth usage</T></p>
          <Coming_soon_label/>
        </div>
      </div> : <div className={cn(styles.empty_block, styles.empty_stats)}>
        <Svg_trash width={79} height={112}/>
        <p className={cn(theme.p1, theme.med)}>
          <T>You currently don't have any active usage stats</T></p>
        <Button caption="Select plan" color={'black'} target="_blank"
          as_external to={'/pricing'} size={'sm'} round={false}/>
      </div>}
    </Fragment>;
};

const Coming_soon_label = ()=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <div className={styles.coming_soon}>
      <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"
        viewBox="0 0 4 4" fill="none">
        <circle cx="2" cy="2" r="2" fill="#9A6F5C"/>
      </svg> <p className={cn(theme.u4, theme.med)}><T>coming soon</T></p>
    </div>;
};
